import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from 'navigation/components/AppRouter';
import { reportWebVitals } from 'app/config/reportWebVitals';
import { SecurityProvider } from 'auth/contexts/SecurityContext';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'overlayscrollbars/overlayscrollbars.css';
import { AppLayout } from 'app/layout';
import { LoadingSpinnerProvider } from 'shared/spinner';
import { NotificationProvider } from 'shared/notifications/contexts/NotificationContext';
import { Provider as OrbitaProvider } from '@orbita-ui/core';
import { CSSReset } from 'app/styles/CSSReset';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  (
    <React.StrictMode>
      <OrbitaProvider variant="theme-prisma">
        <CSSReset />
        <BrowserRouter>
          <NotificationProvider>
            <LoadingSpinnerProvider>
              <SecurityProvider>
                <AppLayout>
                  <AppRouter />
                </AppLayout>
              </SecurityProvider>
            </LoadingSpinnerProvider>
          </NotificationProvider>
        </BrowserRouter>
      </OrbitaProvider>
    </React.StrictMode>
  ) as any,
);

// CRA-vitals: https://bit.ly/CRA-vitals
reportWebVitals();
